import {
  Checkbox,
  CircularProgress,
  FormControlLabel,
  ListItem,
  ListItemIcon,
  MenuItem,
  Tooltip,
  Typography,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import ChatIcon from "@material-ui/icons/Chat";
import InfoIcon from "@material-ui/icons/Info";
import NotificationsIcon from "@material-ui/icons/Notifications";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import SortableTable from "../../Components/SortableTable";
import Title from "../../Components/Title";

import { useTranslation } from "react-i18next";
import {
  ECABIN,
  findValueInText,
  formatClientInfoString,
  formatTimeWithTZOffset,
  getToken,
  getUser,
  invoiceIssuers,
  paymentStates,
  requestErrorHandler,
  searchMatchingList,
} from "../../Utils/Common";
import EnvSettings from "../../Utils/EnvSettings";
import { useStyles } from "../../Utils/Styles";
import EditOrder from "./EditOrder";
import NewOrder from "./NewOrder";

const server = EnvSettings.server;

export default function Orders(props) {
  const order_id = props?.computedMatch?.params?.order_id;
  const classes = useStyles();
  const [searchList, setSearchList] = useState();
  const [orderList, setOrderList] = useState();
  const [searchValue, setSearchValue] = useState(() => order_id || "");
  const [invoiceIssuer, setInvoiceIssuer] = useState();
  const [filterStates, setFilterStates] = useState(() =>
    order_id
      ? paymentStates.map((m) => m.value)
      : ["waiting", "invoiced", "deposit", "completed", "transit"],
  );
  const [selectedOrder, setSelectedOrder] = useState();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const editBoxRef = useRef(null);

  const checkForComments = (order) => {
    if (order?.Notes.find((f) => f.User)) {
      return (
        <Grid item xs={6}>
          <Tooltip title={t("activeComments")}>
            <ChatIcon color="primary" style={{ fontSize: 20 }} />
          </Tooltip>
        </Grid>
      );
    }
    return null;
  };

  const checkForEmailSubscription = (order) => {
    if (
      order.EmailListOrders.find(
        (f) =>
          f &&
          f.EmailList?.EmailListUsers.find(
            (u) => u.User.id === getUser().userId,
          ),
      ) ||
      order.UserId === getUser().userId
    ) {
      return (
        <Grid item xs={6}>
          <Tooltip title={t("tagged")}>
            <NotificationsIcon color="primary" style={{ fontSize: 20 }} />
          </Tooltip>
        </Grid>
      );
    }
    return null;
  };

  const checkHubspotIntegration = (order) => {
    if (order?.metadata?.dealId) {
      return (
        <Grid item xs={6}>
          <Tooltip
            title={
              t("orders.createdFromHubspot") + " " + order?.metadata?.dealId
            }
          >
            <svg
              viewBox="0 0 16 16"
              height="20px"
              data-test-id="icon-hubspot-logo"
              role="img"
              aria-label="HubSpot logo"
            >
              <title>HubSpot</title>
              <path
                d="M11.6127 10.9174C10.4763 10.9174 9.55512 10.0374 9.55512 8.95201C9.55512 7.86645 10.4763 6.98646 11.6127 6.98646C12.749 6.98646 13.6702 7.86645 13.6702 8.95201C13.6702 10.0374 12.749 10.9174 11.6127 10.9174ZM12.2286 5.16801V3.41954C12.7064 3.20397 13.041 2.74229 13.041 2.20648V2.16612C13.041 1.42664 12.4077 0.821619 11.6336 0.821619H11.5915C10.8174 0.821619 10.1841 1.42664 10.1841 2.16612V2.20648C10.1841 2.74229 10.5187 3.20416 10.9965 3.41972V5.16801C10.2852 5.27306 9.63527 5.55332 9.09927 5.96578L4.07384 2.23138C4.107 2.10973 4.1303 1.9845 4.1305 1.85286C4.13129 1.0155 3.42174 0.335606 2.54479 0.334474C1.66822 0.333532 0.956311 1.01154 0.955323 1.84909C0.954337 2.68665 1.66388 3.36654 2.54084 3.36748C2.82651 3.36786 3.09106 3.29035 3.32283 3.16436L8.26614 6.83803C7.84582 7.44418 7.59944 8.17028 7.59944 8.95201C7.59944 9.77033 7.8701 10.5274 8.32734 11.1499L6.82415 12.5861C6.7053 12.5519 6.58211 12.5282 6.45141 12.5282C5.73101 12.5282 5.14684 13.086 5.14684 13.7742C5.14684 14.4626 5.73101 15.0205 6.45141 15.0205C7.17201 15.0205 7.75599 14.4626 7.75599 13.7742C7.75599 13.6498 7.73112 13.5319 7.69538 13.4184L9.18238 11.9978C9.85738 12.4899 10.698 12.7856 11.6127 12.7856C13.8292 12.7856 15.6257 11.0692 15.6257 8.95201C15.6257 7.03531 14.1517 5.45185 12.2286 5.16801Z"
                fill="#3d57a5"
              ></path>
            </svg>
          </Tooltip>
        </Grid>
      );
    }
    return null;
  };

  const iconBox = (data, d, dd) => {
    var comments = checkForComments(dd);
    var emails = checkForEmailSubscription(dd);
    var hubspot = checkHubspotIntegration(dd);
    if (!comments && !emails && !hubspot) {
      return "";
    }
    return (
      <Grid container spacing={1}>
        {comments}
        {emails}
        {hubspot}
      </Grid>
    );
  };

  const executeScroll = () => {
    editBoxRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const showOrder = (dev) => {
    setSelectedOrder();
    // Hack for refreshing the selected device component
    setTimeout(() => {
      setSelectedOrder(dev);
      if (editBoxRef && editBoxRef.current) {
        executeScroll();
      }
    }, 1);
  };

  const getOrders = (ser_val) => {
    setLoading(true);
    setSearchList();
    setSelectedOrder();
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
      }),
    };
    fetch(server + "/get_orders", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          setOrderList(result.orders);
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  useEffect(getOrders, []);

  const filterResults = () => {
    setSearchList(
      orderList &&
        orderList.filter((contact) => {
          return (
            filterStates.find((o) => o === contact.paymentStatus) &&
            searchMatchingList(
              [
                contact.number,
                contact.clientInfo,
                contact.genericDevices,
                contact.Devices,
                contact.User,
                contact.metadata,
              ],
              searchValue,
            ) &&
            (!invoiceIssuer ||
              findValueInText(contact.invoiceIssuer, invoiceIssuer))
          );
        }),
    );
  };
  useEffect(filterResults, [
    searchValue,
    orderList,
    filterStates,
    invoiceIssuer,
  ]);

  return (
    <Grid container spacing={3}>
      <NewOrder />
      <Grid item xs={12}>
        <Paper className={classes.paper} style={{ overflow: "hidden" }}>
          <Grid container spacing={3} alignItems="center">
            <Grid item container spacing={3} xs={12}>
              <Grid item xs={12}>
                <Title>{t("orders.header")}</Title>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                autoFocus
                label={t("search")}
                type="text"
                fullWidth
                variant="outlined"
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e.target.value.toLowerCase());
                }}
                ref={editBoxRef}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                label={t("orders.invoiceIssuer")}
                variant="outlined"
                select
                fullWidth
                onChange={(e) => {
                  setInvoiceIssuer(e.target.value);
                }}
              >
                {["", ...Object.keys(invoiceIssuers)].map((m, i) => (
                  <MenuItem key={m + i} value={m}>
                    {(m ? invoiceIssuers[m].name : null) || t("select")}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </Paper>
      </Grid>

      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <EditOrder selectedOrder={selectedOrder} />
          {searchList ? (
            <>
              <Grid container item xs={12}>
                <Grid item xs={11}>
                  <Typography>{t("orders.paymentStatus")}</Typography>
                  {paymentStates.map((o) => (
                    <FormControlLabel
                      key={o.label}
                      control={
                        <Checkbox
                          color="primary"
                          style={{
                            color: o.color || "",
                          }}
                          onChange={(e, v) => {
                            if (v) {
                              setFilterStates([...filterStates, o.value]);
                              return;
                            }
                            setFilterStates([
                              ...filterStates.filter((f) => f !== o.value),
                            ]);
                          }}
                          defaultChecked={
                            !!filterStates.find((f) => f === o.value)
                          }
                        />
                      }
                      label={t("paymentStates." + o.value)}
                    />
                  ))}
                </Grid>
                <Grid item xs={1}>
                  <Typography style={{ textAlign: "center" }}>
                    Backlog Total{" "}
                    {orderList.reduce(
                      (partialSum, a) =>
                        a.paymentStatus === "invoiced" ||
                        a.paymentStatus === "deposit"
                          ? partialSum + a.totalPrice - a.depositAmount
                          : partialSum,
                      0,
                    )}
                  </Typography>
                </Grid>
              </Grid>
              <SortableTable
                header={t("orders.header")}
                tableLayout={"fixed"}
                downloadButton={true}
                headCells={[
                  {
                    id: "Notes",
                    label: "",
                    width: 70,
                    hideFromCsv: true,
                  },
                  {
                    id: "updatedAt",
                    numeric: false,
                    disablePadding: false,
                    label: t("updatedAt"),
                    // width: 105,
                  },
                  {
                    id: "createdAt",
                    numeric: false,
                    disablePadding: false,
                    label: t("createdAt"),
                    // width: 105,
                  },
                  {
                    id: "User.fullName",
                    numeric: false,
                    disablePadding: false,
                    label: t("createdBy"),
                  },
                  {
                    id: "invoiceIssuer",
                    numeric: false,
                    disablePadding: false,
                    label: t("orders.invoiceIssuer"),
                  },
                  {
                    id: "number",
                    numeric: false,
                    disablePadding: false,
                    label: t("orders.orderNumber"),
                  },
                  {
                    id: "paymentStatus",
                    numeric: false,
                    disablePadding: false,
                    label: t("orders.paymentStatus"),
                  },
                  {
                    id: "clientInfo",
                    numeric: false,
                    disablePadding: false,
                    label: t("clientInfo"),
                  },
                  {
                    id: "genericDevices",
                    numeric: false,
                    disablePadding: false,
                    label: t("items"),
                  },
                  {
                    id: "Devices",
                    numeric: false,
                    disablePadding: false,
                    label: t("orders.allocatedSerialNumbers"),
                  },
                  {
                    id: "depositAmount",
                    numeric: false,
                    disablePadding: false,
                    label: "Backlog",
                  },
                ]}
                // disablePagination: true,
                defaultSortRow={"updatedAt"}
                handleRowClick={showOrder}
                getRowStyle={(data) => {
                  var obj = { cursor: "pointer" };
                  var p = paymentStates.find(
                    (f) => data.paymentStatus === f.value,
                  );
                  if (p && p.color) {
                    return { ...obj, backgroundColor: p.color };
                  }
                  return obj;
                }}
                specialDataFormatting={[
                  {
                    id: "updatedAt",
                    format: (data, d, dd) => {
                      if (dd.Notes && dd.Notes.length) {
                        const max = dd.Notes.reduce((prev, current) =>
                          prev && prev.id > current.id ? prev : current,
                        );
                        return formatTimeWithTZOffset(max.updatedAt, ECABIN);
                      }
                      return formatTimeWithTZOffset(data, ECABIN);
                    },
                  },
                  {
                    id: "Notes",
                    format: iconBox,
                  },
                  {
                    id: "createdAt",
                    format: (data) => {
                      return formatTimeWithTZOffset(data, ECABIN);
                    },
                  },
                  {
                    id: "clientInfo",
                    format: (data) => {
                      return formatClientInfoString(data, [
                        "companyName",
                        "contactName",
                        "location",
                      ]);
                    },
                  },
                  {
                    id: "genericDevices",
                    format: (data) => {
                      var x;
                      if (searchValue && searchValue !== "") {
                        x = data.filter(
                          (f) =>
                            f.name.toLowerCase().includes(searchValue) ||
                            f.sku.toLowerCase().includes(searchValue),
                        );
                        if (x.length) {
                          return (
                            <>
                              {x.map((v) => (
                                <Typography
                                  style={{
                                    backgroundColor: "yellow",
                                    fontSize: 15,
                                  }}
                                >
                                  {v.count + " x " + v.name}
                                </Typography>
                              ))}
                            </>
                          );
                        }
                      }
                      if (data && data.length > 1) {
                        x = 0;
                        data.forEach((d) => (x = x + d.count));
                        return t("count") + ":" + x;
                      }
                      var a = "";
                      data.forEach((v) => (a = v.count + " x " + v.name));
                      return a;
                    },
                  },
                  {
                    id: "Devices",
                    format: (data, d, dd) => {
                      if (data && data.length) {
                        return data.map((m) => m.serialNumber).join(" ");
                      }
                      if (
                        dd.paymentStatus !== "cancelled" &&
                        data &&
                        !data.length &&
                        dd.genericDevices.find(
                          (m) =>
                            m.sku.toLowerCase().includes("ctn_ec_w_220") ||
                            m.sku.toLowerCase().includes("ctn_ec_g_220"),
                        )
                      ) {
                        return t("orders.allocationNeeded");
                      }
                      return "";
                    },
                  },
                  {
                    id: "paymentStatus",
                    formatReturnsElement: true,
                    format: (data, e, v) => {
                      if (e === "json") {
                        return t(
                          "paymentStates." +
                            paymentStates.find((o) => o.value === data).value,
                        );
                      }
                      return (
                        <ListItem>
                          {t(
                            "paymentStates." +
                              paymentStates.find((o) => o.value === data).value,
                          )}
                          {data === "transit" && v.multipleShipments ? (
                            <Tooltip
                              title={t("orders.multipleShipments")}
                              placement="top"
                            >
                              <ListItemIcon size="small">
                                <InfoIcon
                                  style={{ verticalAlign: "middle" }}
                                  fontSize="small"
                                />
                              </ListItemIcon>
                            </Tooltip>
                          ) : null}
                        </ListItem>
                      );
                    },
                  },
                  {
                    id: "invoiceIssuer",
                    format: (data) => {
                      if (!data) {
                        return "";
                      }
                      return Object.entries(invoiceIssuers).find(
                        ([k, o], v) => {
                          if (k === data) return o;
                          return undefined;
                        },
                      )[1].name;
                    },
                  },
                  {
                    id: "depositAmount",
                    format: (data, d, row) => {
                      if (
                        !(
                          row.paymentStatus === "invoiced" ||
                          row.paymentStatus === "deposit"
                        )
                      ) {
                        return "";
                      }
                      return row.totalPrice - row.depositAmount;
                    },
                  },
                ]}
                // handleScrollClick: showDeviceNewTab,
                tableData={searchList}
                rowsPerPage={50}
              />
            </>
          ) : loading ? (
            <CircularProgress />
          ) : undefined}
        </Paper>
      </Grid>
    </Grid>
  );
}
